import {
    useState,
    useEffect
} from 'react';
import {
    useSelector
} from 'react-redux'

const API_URL = process.env.REACT_APP_API_URL;
const REQTOKEN = process.env.REACT_APP_CSRF_REQUEST_TOKEN;

const getCookie = (name) => {
    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
};

const useCsrfToken = () => {
    const user = useSelector((state) => state.authentication?.user);
    const [csrfToken, setCsrfToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                await fetch(`${API_URL}/public-auth/${REQTOKEN}`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                const xsrfToken = getCookie('XSRF-TOKEN');
                setCsrfToken(xsrfToken);
                if (!user) {
                    localStorage.setItem('token', xsrfToken);
                }
            } catch (err) {
                console.error('Error fetching CSRF token:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCsrfToken();
    }, [user]);

    return {
        csrfToken,
        loading,
        error
    };
};

export default useCsrfToken;